import React from 'react';
import {  Container } from 'react-bootstrap';
import VerticalSteps from './VerticalSteps';


const milestonesData = [
  {
    title: 'Earliest Retirement',
    date: '20/30/30',
    age: 50,
    firstSubTitle: {
      title: 'Qualified Pension Plan',
      amount: 40.22,
      plans: [
        { title: 'Plan 1', amount: 23.3 },
        { title: 'Plan 2', amount: 1.9 },
        { title: 'Plan 3', amount: 15.02 },
      ],
    },
    secondSubTitle: { title: 'Non-Qualified Pension Plan ', amount: 42331.2 },
  },
  {
    title: 'Earliest Retirement',
    date: '20/30/30',
    age: 55,
    firstSubTitle: {
      title: 'Qualified Pension Plan',
      amount: 40.22,
      plans: [
        { title: 'Plan 1', amount: 23.3 },
        { title: 'Plan 2', amount: 1.9 },
        { title: 'Plan 3', amount: 15.02 },
      ],
    },
    secondSubTitle: { title: 'Non-Qualified Pension Plan ', amount: 42331.2 },
  },
  {
    title: 'Earliest Retirement',
    date: '20/30/30',
    age: 60,
    firstSubTitle: {
      title: 'Qualified Pension Plan',
      amount: 40.22,
      plans: [
        { title: 'Plan 1', amount: 23.3 },
        { title: 'Plan 2', amount: 1.9 },
        { title: 'Plan 3', amount: 15.02 },
      ],
    },
    secondSubTitle: { title: 'Non-Qualified Pension Plan ', amount: 42331.2 },
  },
];

const VerticalStepsDemo = () => {
  return (
    <>
      <h4 className="mt-13">Vertical Steps</h4>
      <Container className="vertical-steps-container">
        <VerticalSteps data={milestonesData} />
      </Container>
    </>
  );
};

export default VerticalStepsDemo;
